import { GameTitle } from "./GameTitle";
import { Confetti } from "../Confetti";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";
import { AudioButtonsContainer } from "../AudioButtonsContainer";

export class SplashState extends Phaser.State {

    public static currentInstance: SplashState;

    private playButton: Phaser.Button;
    private musicOnButton: Phaser.Button;
    private musicOffButton: Phaser.Button;
    private fxOnButton: Phaser.Button;
    private fxOffButton: Phaser.Button;
    private creditsButton: Phaser.Button;
    private statsButton: Phaser.Button;
    private fadeInLayer: Phaser.Sprite;
    private gameTitle: GameTitle;
    private confetti: Confetti;

    public create(): void {

        SplashState.currentInstance = this;

        const background = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "splash-background");
        background.anchor.set(.5);
        background.scale.y = GameVars.scaleY;

        this.confetti = new Confetti(this.game);
        this.add.existing(this.confetti.backgroundConfettiContainer);
        this.add.existing(this.confetti.foregroundConfettiContainer);

        // el pato y el messi
        this.add.image(500, 350, "texture_atlas_2", "splash_pato");

        const messi = this.add.image(15, 686, "texture_atlas_2", "splash_messi");
        messi.scale.y = GameVars.scaleY;

        this.gameTitle = new GameTitle(this.game);
        this.add.existing(this.gameTitle);

        // el boton de play
        this.playButton = this.add.button(670, 910, "texture_atlas_5", this.onClickPlay, this);
        this.playButton.setFrames("play_button_on", "play_button_off", "play_button_on");
        this.playButton.scale.set(0);
        this.playButton.anchor.set(.5);

        this.addAudioButtons();

        this.creditsButton = this.add.button(690, 35, "texture_atlas_5", this.onClickCredits, this);
        this.creditsButton.setFrames("credits_on", "credits_off", "credits_on");
        this.creditsButton.anchor.setTo(.5);
        this.creditsButton.scale.setTo(0, 1);

        this.statsButton = this.add.button(690, 95 * GameVars.scaleY, "texture_atlas_5", this.onClickStats, this);
        this.statsButton.setFrames("stats_on", "stats_off", "stats_on");
        this.statsButton.anchor.set(.5);
        this.statsButton.scale.setTo(0);

        // etiqueta con el copyright
        // const copyRightLabel = this.add.text(170, 1000, "Copyright ©2015 RavalMatic. Licensed to Freeze Nova" + GameConstants.SPONSOR, { font: "19.5px Arial", fill: "#EEEEEE", align: 'center'} );
        // copyRightLabel.scale.y = GameVars.scaleY;

        const logo = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 50 * GameVars.scaleY, "logo");
        logo.anchor.set(.5);
        logo.scale.x = .55;
        logo.scale.y = .55 * GameVars.scaleY;

        this.fadeInLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData("intro_background"));
        this.fadeInLayer.scale.set(48, 16);

        this.add.tween(this.fadeInLayer).to({ alpha: 0 }, 1100, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.fadeInLayer.destroy();
            }, this);

        this.game.time.events.add(500, this.showTitle, this);

        this.game.time.events.add(1750, function (): void {
            this.confetti.activate();
        }, this);
    }

    public shutdown(): void {

        SplashState.currentInstance = null;

        this.confetti = null;

        super.shutdown();
    }

    public update(): void {

        this.confetti.update();
    }

    public showButtons(): void {

        this.game.add.tween(this.playButton.scale)
            .to({ x: 1, y: GameVars.scaleY }, 700, Phaser.Easing.Elastic.Out, true, 100)
            .onComplete.add(this.startPlayButtonAnimation, this);

        this.game.add.tween(this.statsButton.scale)
            .to({ x: 1, y: GameVars.scaleY }, 600, Phaser.Easing.Bounce.Out, true, 900);

        if (this.creditsButton) {
            this.game.add.tween(this.creditsButton.scale)
                .to({ x: 1, y: GameVars.scaleY }, 600, Phaser.Easing.Bounce.Out, true, 800);
        }

        // los tweens a los botones laterales
        this.game.add.tween(this.musicOnButton.scale)
            .to({ x: 1, y: GameVars.scaleY }, 600, Phaser.Easing.Bounce.Out, true, 1000);

        this.game.add.tween(this.musicOffButton.scale)
            .to({ x: 1, y: GameVars.scaleY }, 600, Phaser.Easing.Bounce.Out, true, 1000);

        this.game.add.tween(this.fxOnButton.scale)
            .to({ x: 1, y: GameVars.scaleY }, 600, Phaser.Easing.Bounce.Out, true, 1100);

        this.game.add.tween(this.fxOffButton.scale)
            .to({ x: 1, y: GameVars.scaleY }, 600, Phaser.Easing.Bounce.Out, true, 1100);
    }

    public goToScene(nextScene: string): void {

        this.fadeInLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData("black_square"));
        this.fadeInLayer.scale.set(12, 16);
        this.fadeInLayer.alpha = 0;

        this.add.tween(this.fadeInLayer)
            .to({ alpha: 1 }, 700, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.game.state.start(nextScene, true, false);
            }, this);
    }

    private addAudioButtons(): void {

        this.musicOnButton = this.add.button(724, 160 * GameVars.scaleY, "texture_atlas_5", this.onClickMusicOn, this, 1, 0, 1);
        this.musicOnButton.setFrames("music_on_button_on", "music_on_button_off", "music_on_button_on", "music_on_button_off");
        this.musicOnButton.anchor.setTo(.5);
        this.musicOnButton.scale.setTo(1, 0);

        this.musicOffButton = this.add.button(724, 160 * GameVars.scaleY, "texture_atlas_5", this.onClickMusicOff, this, 1, 0, 1);
        this.musicOffButton.setFrames("music_off_button_on", "music_off_button_off", "music_off_button_on", "music_off_button_off");
        this.musicOffButton.anchor.setTo(.5);
        this.musicOffButton.scale.setTo(1, 0);

        if (AudioManager.getInstance().isMusicMuted) {
            this.musicOnButton.visible = false;
        } else {
            this.musicOffButton.visible = false;
        }

        // fx
        this.fxOnButton = this.add.button(724, 232 * GameVars.scaleY, "texture_atlas_5", this.onClickFxOn, this, 1, 0, 1);
        this.fxOnButton.setFrames("fx_button_on_on", "fx_button_on_off", "fx_button_on_on", "fx_button_on_off");
        this.fxOnButton.anchor.setTo(.5);
        this.fxOnButton.scale.setTo(1, 0);

        this.fxOffButton = this.add.button(724, 232 * GameVars.scaleY, "texture_atlas_5", this.onClickFxOff, this, 1, 0, 1);
        this.fxOffButton.setFrames("fx_button_off_on", "fx_button_off_off", "fx_button_off_on", "fx_button_off_off");
        this.fxOffButton.anchor.setTo(.5);
        this.fxOffButton.scale.setTo(1, 0);

        if (AudioManager.getInstance().areEffectsMuted) {
            this.fxOnButton.visible = false;
        } else {
            this.fxOffButton.visible = false;
        }

        AudioManager.getInstance().musicOnButton = this.musicOnButton;
        AudioManager.getInstance().musicOffButton = this.musicOffButton;
        AudioManager.getInstance().fxOnButton = this.fxOnButton;
        AudioManager.getInstance().fxOffButton = this.fxOffButton;
    }

    private startPlayButtonAnimation(): void {

        const pulseTween = this.game.add.tween(this.playButton.scale);
        pulseTween.to({ x: 1.05, y: .95 * GameVars.scaleY }, 300, Phaser.Easing.Linear.None, false);
        pulseTween.delay(50);
        pulseTween.to({ x: .95, y: 1.05 * GameVars.scaleY }, 700, Phaser.Easing.Elastic.Out);
        pulseTween.loop();
        pulseTween.start();
    }

    private showTitle(): void {

        this.gameTitle.startAnimation();
    }

    private onClickMusicOn(): void {

        this.musicOnButton.visible = false;
        this.musicOffButton.visible = true;

        GameManager.changeAudioPreferences(AudioButtonsContainer.MUSIC_ON);
    }

    private onClickMusicOff(): void {

        this.musicOnButton.visible = true;
        this.musicOffButton.visible = false;

        GameManager.changeAudioPreferences(AudioButtonsContainer.MUSIC_OFF);
    }

    private onClickFxOn(): void {

        this.fxOnButton.visible = false;
        this.fxOffButton.visible = true;

        GameManager.changeAudioPreferences(AudioButtonsContainer.EFFECTS_ON);
    }

    private onClickFxOff(): void {

        this.fxOnButton.visible = true;
        this.fxOffButton.visible = false;

        GameManager.changeAudioPreferences(AudioButtonsContainer.EFFECTS_OFF);
    }

    private onClickPlay(): void {

        GameManager.newGame();

        AudioManager.getInstance().playEffect("play");
    }

    private onClickCredits(): void {

        AudioManager.getInstance().playEffect("play");
        this.goToScene("CreditsState");
    }

    private onClickStats(): void {

        AudioManager.getInstance().playEffect("play");
        this.goToScene("StatsState");
    }
}
